import React, { useState } from 'react';
import { InputNumber } from 'antd';
import { Icon } from '@common/components';
import { Colors } from '@common/tokens';

export const CurrencyInput = ({
  onAction,
  actionKind = 'clear',
  ...props
}: React.ComponentProps<typeof InputNumber> & {
  onAction?: () => void;
  actionKind?: 'clear' | 'restore';
}) => {
  const [isHover, setIsHover] = useState(false);

  const showActionButton = !!onAction;

  function onActionClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    onAction?.();
  }

  return (
    <>
      <div className="wk-currency-input">
        <InputNumber
          precision={2}
          min={0}
          controls={false}
          prefix="$"
          style={{ width: '100%' }}
          {...props}
        />
        {showActionButton && (
          <button
            className="wk-currency-input__clear-button"
            onClick={onActionClick}
          >
            {actionKind === 'clear' ? (
              <Icon
                icon="circleXmark"
                size="sm"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                color={isHover ? 'steelDarkest' : 'steelDarker'}
              />
            ) : (
              <Icon icon="undo" color="elm" />
            )}
          </button>
        )}
      </div>
      <style jsx>{`
        .wk-currency-input {
          position: relative;
        }

        .wk-currency-input :global(.ant-input-number-prefix) {
          margin-right: 8px;
        }

        .wk-currency-input__clear-button {
          position: absolute;
          z-index: 1;
          right: 3px;
          background-color: transparent;
          border: none;
          outline: none;
          cursor: pointer;
          opacity: 0;
          top: 0;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.3s ease-in-out;
        }
        .wk-currency-input:hover .wk-currency-input__clear-button {
          opacity: 1;
        }
        .wk-currency-input :global(.ant-input-number-prefix) {
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </>
  );
};
